"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VWOEvents = void 0;
var VWOEvents;
(function (VWOEvents) {
    VWOEvents["USER_CLICKED_ON_SEND_ORDER"] = "clickOnSendOrderOnCart";
    VWOEvents["USER_CLICKED_ON_CHOOSE_MORE"] = "clickOnChooseMoreOnCart";
    VWOEvents["CLICK_ON_VIEW_PRODUCT"] = "clickOnViewProduct";
    VWOEvents["CLICK_ON_CHANGE_PRODUCT_QUANTITY"] = "clickOnChangeProductQuantity";
    VWOEvents["CLICK_ON_REMOVE_PRODUCT_FROM_CART"] = "clickOnRemoveProductFromCart";
    VWOEvents["USER_SKIPPED_CUSTOMER_RECOGNITION"] = "skipCustomerRecognition";
    VWOEvents["USER_COMPLETED_CHECKOUT"] = "successOnCreateOrder";
    VWOEvents["CLICK_ON_GO_TO_CART"] = "clickOnGoToCart";
    VWOEvents["SUCCESS_ON_CUSTOMER_RECOGNITION"] = "successOnCustomerRecognition";
    VWOEvents["ADD_ITEM_TO_FAVORITES"] = "addItemToWishlist";
    VWOEvents["REMOVE_ITEM_FROM_FAVORITES"] = "removeItemFromWishlist";
    VWOEvents["GO_TO_FAVORITES_ON_HEADER"] = "goToWishlistOnHeader";
    VWOEvents["ADD_PRODUCT_TO_CART"] = "addProductToCart";
    VWOEvents["INTERACTION_WITH_CATALOG"] = "interactionWithCatalog";
    VWOEvents["INTERACTION_WITH_SHOP_WINDOW"] = "interactionWithShopWindow";
    VWOEvents["INTERACTION_WITH_VIDEO_SHOWCASE"] = "interactionWithVideoShowcase";
    VWOEvents["CLICK_ON_DOWNLOAD_CATALOG"] = "clickOnDownloadCatalog";
    VWOEvents["CLICK_ON_HOME_MENU_BUTTON"] = "clickOnHomeMenuButton";
})(VWOEvents = exports.VWOEvents || (exports.VWOEvents = {}));
